import TalaeraRoutes from "components/routes/TalaeraRoutes";
import TalaeraBackground from "components/TalaeraBackground";
import TalaeraSpinner from "components/TalaeraSpinner/TalaeraSpinner";
import { useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { useSearchParams } from "react-router-dom";
import { populateUserSession, verifyUser } from "services/authUtil";
import { logError } from "services/logging";

export default function VerifyPendingUser() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const { t } = useTranslation();

  const verifyUserToken = useCallback(async () => {
    if (!token) {
      navigate(TalaeraRoutes.SIGN_IN.path, {
        state: { error: t("Signup.VerifyPendingUser.invalidLink") },
      });
      return;
    }

    try {
      await verifyUser({ token }, { includeStatusCode: true });
    } catch (err: any) {
      logError("Failed to verify user", err);
      if (err?.statusCode === 404) {
        navigate(TalaeraRoutes.SIGN_IN.path, {
          state: { error: t("Signup.VerifyPendingUser.alreadyUsedLink") },
        });
        return;
      }
      navigate(TalaeraRoutes.SIGN_IN.path, {
        state: { error: t("Signup.VerifyPendingUser.invalidLink") },
      });
    }

    populateUserSession(
      () => {
        navigate(TalaeraRoutes.ROOT.path);
      },
      (err: any) => {
        logError("Failed to load user", err);
        navigate(TalaeraRoutes.SIGN_IN.path, {
          state: { error: t("Signup.VerifyPendingUser.failedToSignIn") },
        });
      }
    );
  }, [navigate, token, t]);

  useEffect(() => {
    verifyUserToken();
  }, [verifyUserToken]);

  return (
    <TalaeraBackground>
      <TalaeraSpinner />
    </TalaeraBackground>
  );
}
